import { render, staticRenderFns } from "./the-notification.html?vue&type=template&id=e57b9e54&scoped=true&"
import script from "./the-notification.js?vue&type=script&lang=js&"
export * from "./the-notification.js?vue&type=script&lang=js&"
import style0 from "./TheNotification.vue?vue&type=style&index=0&id=e57b9e54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e57b9e54",
  null
  
)

component.options.__file = "TheNotification.vue"
export default component.exports